<template>
  <div>
    <div
      class="modal fade"
      id="modalAsignarPlaca"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title">Asignar placa</h6>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12">
              <label>Número de placa</label>
              <input
                focus
                v-on:keyup.enter="AsignarPickingPlaca()"
                type="text"
                class="form-control"
                ref="placax"
                v-model="current.placa"
              />
              <small class="text-danger" v-if="errors && errors.placa">{{
                errors.placa
              }}</small>
            </div>
            <br />
            <br />
            <div class="col-12">
              <button
                @click="AsignarPickingPlaca()"
                type="button"
                class="btn btn-success btn-md btn-block"
              >
                Aceptar
                <i class="fas fa-check"></i>
              </button>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modalListaDePlacas"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h6 class="modal-title">Placa(as) asignada(as)</h6>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12">
              <div class="table-responsive">
                <!-------------------- Tabla de REsultados -------------------->
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="det in placasList" v-bind:key="det.id">
                      <td>
                        <div class="value">
                          <small class="font-weight-bold">{{
                            det.placa
                          }}</small>
                        </div>
                        <small
                          ><div class="value">
                            {{
                              det.fecha_creacion
                                | moment("DD/MM/YYYY hh:mm:ss a")
                            }}
                          </div></small
                        >
                      </td>
                      <td class="text-right">
                        <button
                          @click="desasignarPlaca(det)"
                          class="btn btn-danger btn-sm"
                        >
                          Desasignar placa
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";

export default {
  components: {},
  props: {
    despachoe: {
      type: Object,
    },
    placasList: {
      type: Array,
    },
  },
  data() {
    return {
      current: {},
      errors: [],
    };
  },
  mounted() {
    let self = this;
    $(".modal").on("shown.bs.modal", function () {
      // $(this).find('[autofocus]').focus();
      self.$refs.placax.focus();
    });
  },
  methods: {
    desasignarPlaca(det) {
      DynamicService.getActionList(
        "wms",
        "picking-despacho",
        "desasignar_placa_picking",
        { pedido_e: det.pedido_e_id, placa: det.placa }
      ).then((response) => {
        this.$emit("refreshCurrent");
      });
    },
    AsignarPickingPlaca() {
      DynamicService.postActionList(
        "wms",
        "picking-despacho",
        "asignar_placa_picking",
        { placa: this.current.placa, pedido_e: this.despachoe.id }
      )
        .then((response) => {
          Notifications.alert.success(
            "Asignar placa a este despacho",
            "Realizado correctamente"
          );
          this.current.placa = "";
          this.$emit("refreshCurrent");
          $("#modalAsignarPlaca").modal("hide");
        })
        .catch((errors) => {
          this.errors = errors.response.data;
          Notifications.alert.error(
            "Asignar placa a este despacho",
            errors.response.data.detail
          );
        });
    },
  },
};
</script>
